import { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '../components/Modal';

const POI_ICONS = ['📍', '🏠', '🔧', '⛽', '🚗', '🚐', '🏗️', '⚠️', '🅿️', '🏢'];

export default function AddPOIModal() {
  const { modals, closeModal, pois, setPois, showToast } = useApp();
  const open = !!modals['add-poi'];

  const [name, setName] = useState('');
  const [type, setType] = useState('');
  const [icon, setIcon] = useState('📍');
  const [desc, setDesc] = useState('');
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');

  useEffect(() => {
    if (open) {
      setName(''); setType(''); setIcon('📍'); setDesc('');
      setLat('34.77'); setLng('32.42');
    }
  }, [open]);

  function close() { closeModal('add-poi'); }

  function submit() {
    if (!name.trim()) { alert('POI name is required'); return; }
    const id = 'poi-' + Date.now();
    const latN = Number(lat) || 34.77;
    const lngN = Number(lng) || 32.42;
    // Convert geographic coords to SVG canvas coords (Paphos area map, viewBox 0 0 900 600)
    const x = Math.round(250 + (lngN - 32.424) * 7966);
    const y = Math.round(265 - (latN - 34.775) * 614);
    const newPoi = { id, name, type: type || 'custom', icon, desc, lat: latN, lng: lngN, x, y };
    setPois(prev => [...prev, newPoi]);
    showToast(`POI "${name}" added`);
    close();
  }

  return (
    <Modal open={open} onClose={close} size="sm">
      <ModalHeader
        icon={<span style={{ fontSize: 16 }}>📍</span>}
        title="Add Point of Interest"
        subtitle="Pin a location on the fleet map"
        onClose={close}
      />
      <ModalBody>
        <div className="fg">
          <label className="fl">POI Name *</label>
          <input className="fi" value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Main Garage, Fuel Station" />
        </div>

        <div className="fg">
          <label className="fl">Type</label>
          <input className="fi" value={type} onChange={e => setType(e.target.value)} placeholder="e.g. garage, fuel, parking" />
        </div>

        <div className="fg">
          <label className="fl">Icon</label>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {POI_ICONS.map(i => (
              <div
                key={i}
                onClick={() => setIcon(i)}
                style={{
                  width: 32, height: 32, borderRadius: 6, display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: 18, cursor: 'pointer',
                  border: `2px solid ${icon === i ? 'var(--ac)' : 'var(--bd)'}`,
                  background: icon === i ? 'var(--ac-l)' : 'var(--sur2)',
                }}
              >
                {i}
              </div>
            ))}
          </div>
        </div>

        <div className="fg">
          <label className="fl">Description (optional)</label>
          <input className="fi" value={desc} onChange={e => setDesc(e.target.value)} placeholder="Short description" />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <div className="fg">
            <label className="fl">Latitude</label>
            <input className="fi" type="number" step="0.001" value={lat} onChange={e => setLat(e.target.value)} placeholder="34.770" />
          </div>
          <div className="fg">
            <label className="fl">Longitude</label>
            <input className="fi" type="number" step="0.001" value={lng} onChange={e => setLng(e.target.value)} placeholder="32.420" />
          </div>
        </div>

        <div style={{ fontSize: 10, color: 'var(--tx3)', marginTop: 2 }}>
          Paphos, Cyprus is approximately 34.77°N, 32.42°E
        </div>
      </ModalBody>

      <ModalFooter>
        <button className="btn btn-ghost" onClick={close}>Cancel</button>
        <button className="btn btn-primary" onClick={submit}>Add POI</button>
      </ModalFooter>
    </Modal>
  );
}
